import { render, staticRenderFns } from "./FormC.vue?vue&type=template&id=b71651d0&"
import script from "./FormC.vue?vue&type=script&lang=js&"
export * from "./FormC.vue?vue&type=script&lang=js&"
import style0 from "./FormC.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports